import {
  Component,
  HostBinding,
  ViewChild,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import {
  DashboardFacade,
  type IDashboardListDto,
} from '@clean-code/shared/dashboard/dashboard/domain';
import { TranslocoModule } from '@jsverse/transloco';
import { DashboardEditComponent } from '../dashboard-edit/dashboard-edit.component';

@Component({
  templateUrl: './dashboard-edit-dialog.component.html',
  styleUrls: ['./dashboard-edit-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatDialogModule,
    TranslocoModule,
    DashboardEditComponent,
    ActionButtonModule,
  ],
})
export class DashboardEditDialogComponent {
  @HostBinding('class') class = 'dashboard-dashboard-edit-dialog';

  @ViewChild('editChild', { static: false })
  public editChild: DashboardEditComponent;

  private facade = inject(DashboardFacade);
  public dialogRef = inject(MatDialogRef<DashboardEditDialogComponent>);
  public dashboard = inject(MAT_DIALOG_DATA) as IDashboardListDto;

  public save(): void {
    if (!this.editChild?.form || this.editChild.form.invalid) {
      this.editChild?.form?.markAllAsTouched();
      return;
    }

    this.facade.update$(this.editChild.form.value);
    this.dialogRef.close();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
